import React from 'react'
import { Grid, Image, H, P, Wrapper } from '@farewill/ui'

import { QUESTIONS_COPY } from './constants'

const Questions = (): React.ReactElement => (
  <Grid container containerPaddingTop="XXL" style={{ alignItems: 'center' }}>
    <Grid.Item spanFromM={8} spanFromL={7}>
      {QUESTIONS_COPY.map((text) => (
        <Wrapper key={text.question} margin={[0, 0, 'XL']}>
          <H margin={[0, 0, 'S']} size="M" decorative>
            {text.question}
          </H>
          <P>{text.answer}</P>
        </Wrapper>
      ))}
    </Grid.Item>
    <Grid.Item spanFromM={4} spanFromL={5} centered>
      <Image
        path="illustrations/blob-bird-binoculars"
        width={200}
        widthFromM={470}
        stretch
      />
    </Grid.Item>
  </Grid>
)

export default Questions
